<div class="sfcid-details">
  <div class="details-header">
    {{ 'SF_CONNECTIONS.CONNECTED_DETAILS_TITLE' | translate }}
  </div>
  <ng-container *ngFor="let item of items">
    <div class="detail-item">
      <div class="details-w-icon-container">
        <mat-icon
          class="q9-logo-color details-icon details-{{ item.icon }}"
          [svgIcon]="item.icon"></mat-icon>
        <div class="details-info">
          <div class="label">{{ item.title | translate }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
